<template>
  <el-cascader
    ref="cascaderRef"
    v-model="defaultValue"
    :options="options"
    :props="props"
    :placeholder="placeholder"
    clearable
    :disabled="readonly"
    filterable
    @blur="handleBlur"
    @change="handleChange"
    style="width: 100%;">
  </el-cascader>
</template>
<script>
import { tree, treeByCodes } from '@/api/category';
export default {
  props: {
    type: {
      type: String,
      default: null,
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    size: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default () {
        return '请选择平台商品分类';
      },
    },
    checkStrictly: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      defaultValue: [],
      options: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: this.checkStrictly,
      },
    };
  },
  methods: {
    handleBlur () {
      this.$emit('handleValidate');
    },
    handleClear () {
      this.defaultValue = [];
      this.$emit('handleSelect', { value: [], selectedPathLabel: '' });
      this.$emit('handleValidate');
    },
    handleChange (value) {
      const selectedNodes = this.$refs.cascaderRef.getCheckedNodes();
      const selectedPathLabel = selectedNodes?.length ? selectedNodes[0].pathLabels.join(',') : '';
      this.$emit('handleSelect', { value, selectedPathLabel });
    },
    getCategoryLists () {
      const api = this.type === 'MEDICAL' ? tree : treeByCodes;
      const params = this.type === 'MEDICAL' ? {} : {
        codes: ['MEDICAL_DEVICE', 'NON_MEDICAL_DEVICE'],
        enableFlag: true,
        includeSelfFlag: true,
      };
      api(params).then(res => {
        if (this.type === 'MEDICAL') {
          this.options = (res.body || []).filter(item => ['DEVICE', 'PART'].includes(item.code));
        } else {
          this.options = (res.body || []);
        }
      });
    },
  },
  created () {
    this.getCategoryLists();
  },
};
</script>
